import { render, staticRenderFns } from "./LinkedAccountDefaults.vue?vue&type=template&id=4aabea92&scoped=true"
import script from "./LinkedAccountDefaults.vue?vue&type=script&lang=ts"
export * from "./LinkedAccountDefaults.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aabea92",
  null
  
)

export default component.exports